"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sys_cons = require("@/api/sys_cons");
var _red_packet = require("@/api/activity/red_packet");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'RedPacketTablePane',
  components: {},
  data: function data() {
    return {
      imageAccessDomain: '',
      listLoading: false,
      searchForm: {
        id: '',
        title: '',
        page: 1,
        limit: 10
      },
      total: 0,
      tableData: [],
      qrDialogVisible: false,
      qrImage: '',
      qrObj: {}
    };
  },
  created: function created() {
    this.getImageAccessDomain();
    this.handleSearch();
  },
  methods: {
    handleCreate: function handleCreate() {
      this.$emit('create');
    },
    getImageAccessDomain: function getImageAccessDomain() {
      var _this = this;
      (0, _sys_cons.queryImageAccessDomain)().then(function (res) {
        var data = res.data;
        if (data) {
          _this.imageAccessDomain = data;
        }
      });
    },
    handleSearch: function handleSearch() {
      this.searchForm.page = 1;
      this.getRedPacketActivityPage();
    },
    getRedPacketActivityPage: function getRedPacketActivityPage() {
      var _this2 = this;
      this.listLoading = true;
      (0, _red_packet.queryRedPacketActivityPage)(this.searchForm).then(function (res) {
        var data = res.data;
        if (data) {
          _this2.tableData = data.records;
          _this2.total = data.total;
        }
        _this2.listLoading = false;
      }, function () {
        _this2.listLoading = false;
      });
    },
    handleReset: function handleReset() {
      console.log('handleReset');
      this.searchForm.id = '';
      this.searchForm.title = '';
      this.searchForm.page = 1;
      this.searchForm.limit = 10;
    },
    handleSizeChange: function handleSizeChange(val) {
      this.searchForm.limit = val;
      this.getRedPacketActivityPage();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchForm.page = val;
      this.getRedPacketActivityPage();
    },
    handleEdit: function handleEdit(row) {
      this.$emit('edit', row.idd);
    },
    handleCopyToCreate: function handleCopyToCreate(row) {
      var _this3 = this;
      this.$confirm('是否复制该活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _this3.$emit('copy', row.idd);
      }).catch(function () {
        _this3.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleCopy: function handleCopy(row) {
      var _this4 = this;
      this.$confirm('是否复制该活动？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _red_packet.copyRedPacketActivity)(row.idd).then(function () {
          _this4.handleSearch();
        });
      }).catch(function () {
        _this4.$message({
          type: 'info',
          message: '已取消'
        });
      });
    },
    handleQrCode: function handleQrCode(row) {
      console.log('row', row);
      var url = 'https://api.gagacafe.com/redpacket/' + row.idd;
      console.log('url', url);

      // 使用第三方二维码生成服务（qrserver）
      var size = 500;
      var qrApi = "https://api.qrserver.com/v1/create-qr-code/?size=".concat(size, "x").concat(size, "&data=").concat(encodeURIComponent(url));

      // 直接将生成链接赋值给图片 src，弹窗显示
      this.qrImage = qrApi;
      this.qrObj = row;
      this.qrDialogVisible = true;
    },
    handleActivityDetail: function handleActivityDetail(row) {
      this.$emit('statistics', row.idd, row.title);
    }
  }
};